<div class="layout-container">
  <app-header (toggleSidebar)="toggleSidebar()"></app-header>

  <div class="layout-body">
    <app-sidebar [isOpen]="sidebarOpen"
                 (requestSidebarOpen)="openSidebar()"
                 (requestSidebarClose)="closeSidebar()"></app-sidebar>

    <!-- `tabindex="-1"` makes this landmark focusable by CODE without adding a
         stop to the Tab sequence: it is where the lateral menu hands the
         keyboard after a leaf is activated with Enter/Space, so the journey
         does not end on a menu item the closing cascade just removed
         (TASK-61043, AC19/AC4). The selector the menu resolves it by is
         `CONTENT_REGION_SCOPE` in `menu-focus.service.ts`. -->
    <main class="main-content" tabindex="-1" [class.sidebar-open]="sidebarOpen">
      <ng-content></ng-content>
    </main>
  </div>

  <app-footer></app-footer>

  <!--
    Mobile drawer is mounted only when the viewport is mobile or tablet.
    The desktop sidebar above stays in the DOM but is hidden via SCSS at
    `<1024px` so its existing behavior on desktop is byte-identical.
  -->
  <app-menu-drawer
    *ngIf="viewport.isMobile() || viewport.isTablet()"
    [items]="(menuItems$ | async) ?? []"
    [currentUrl]="currentUrl"
  ></app-menu-drawer>

  <!--
    Overlay pages below (Health Facilities, Collection Queues, Vacinas configuration,
    Cash Control, Laboratory Sectors) are loaded on first open, not bundled with the layout —
    see layout-overlays.ts. `ngComponentOutlet` with `null` renders nothing.
  -->

  <!--
    Health Facilities listing overlay (TASK-60341). Mounted only while the modal
    service reports it open, so it costs nothing when closed and renders on top
    of the current page (scrim over the dimmed page/sidebar) — no navigation.
  -->
  <ng-container *ngComponentOutlet="healthFacilitiesPage$ | async"></ng-container>

  <!--
    Collection Queues listing overlay (US #60630). Mounted only while the modal
    service reports it open, so it costs nothing when closed and renders on top
    of the current page (scrim over the dimmed page/sidebar) — no navigation.
  -->
  <ng-container *ngComponentOutlet="collectionQueuesPage$ | async"></ng-container>

  <!--
    Vacinas configuration overlay (US #61577). Same contract as the two above:
    mounted only while the modal service reports it open, rendered on top of the
    current page, no navigation — so the page behind it survives (C-1.1/C-1.2).
  -->
  <ng-container *ngComponentOutlet="vaccinesConfigPage$ | async"></ng-container>

  <!--
    Laboratory Sectors listing overlay (US #61003). Mounted only while the modal service reports it
    open, so it costs nothing when closed and renders on top of the current page (scrim over the
    dimmed page/sidebar) — no navigation, no URL change, no history entry.
  -->
  <ng-container *ngComponentOutlet="laboratorySectorsPage$ | async"></ng-container>

  <!--
    Clinics listing overlay (TASK-60770). Mounted only while the modal service
    reports it open, so it costs nothing when closed and renders on top of the
    current page (scrim over the dimmed page/sidebar) — no navigation, which is
    why `/clinics` is deliberately NOT an SPA-internal route. Loaded on first
    open through LAYOUT_OVERLAY_LOADERS, like its siblings.
  -->
  <ng-container *ngComponentOutlet="clinicsPage$ | async"></ng-container>

  <!--
    Cadastro de Paciente window (US 62835), opened by the Recepção menu item. Same contract as the
    overlays above: mounted only while open, over the current page, with no navigation.
  -->
  <ng-container *ngComponentOutlet="patientRegistryWindow$ | async"></ng-container>

  <!--
    Tabela de Preços listing overlay (US #62189). Same contract as the overlays above: mounted only while the modal
    service reports it open, over the current page — no navigation, no URL change, no history entry.
  -->
  <ng-container *ngComponentOutlet="priceTablesPage$ | async"></ng-container>

  <!--
    Fechamento de Caixa overlay (US #61506). Mounted only while the modal service reports it open — no
    navigation, no URL change, no history entry (D-17). Opened by the Fechamento de Caixa button of the
    Controle de Caixa action bar ([OQ-18], D-102), so it stacks OVER that overlay: it must stay AFTER the
    Controle de Caixa outlet above — all surfaces share `--z-modal`, paint order is document order, and
    the shell's registry gives Esc to the last one.
  -->
  <ng-container *ngComponentOutlet="cashClosingModal$ | async"></ng-container>

  <!--
    Movimentação do Caixa overlay (US #61510). Same contract as the Fechamento de Caixa above: mounted only while the
    modal service reports it open — no navigation, no URL change, no history entry (D-17). Opened by the Movimentação
    button of the Controle de Caixa header (D-106), so it stacks OVER that page.
  -->
  <ng-container *ngComponentOutlet="cashMovementReportModal$ | async"></ng-container>
</div>
